/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ServizioMensaEsenzioneForm { 
    is_esente?: boolean;
    motivo_esenzione?: string;
    ricalcola_portafogli?: boolean;
    valida_dal?: string;
}

